import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-100 h-100 position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "loading-options-container"
}
const _hoisted_4 = {
  key: 1,
  class: "no-results"
}
const _hoisted_5 = {
  key: 0,
  class: "checkmark-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "loading-more-options-container"
}

import { ref, computed, watch, VNode } from 'vue';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue';

import { CheckmarkIcon, CaretDownIcon } from '@/components/svg';
import { InputVariant, IOptions } from '@/types';

interface Props {
  label?: string;
  placeholder?: string;
  labelIcon?: string | object | (() => VNode) | null;
  required?: boolean;
  variant?: InputVariant;
  modelValue?: string | number;
  options?: IOptions[];
  testId?: string;
  loadingOptions?: boolean;
  loadingMoreOptions?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchSelect',
  props: {
    label: { default: "" },
    placeholder: { default: "" },
    labelIcon: { type: [String, Object, Function, null], default: null },
    required: { type: Boolean, default: false },
    variant: { default: "primary" },
    modelValue: { default: "" },
    options: { default: () => [] },
    testId: { default: "search-select" },
    loadingOptions: { type: Boolean, default: false },
    loadingMoreOptions: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "update:query", "load-more-options"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selected = ref<IOptions | null>(null);
const query = ref<string>('');
const optionsRef = ref<HTMLElement | null>(null);

const variantClass = computed(() => props.variant ?? 'primary');
const backgroundStyle = computed(() => ({
  background:
    selected.value && ["primary", "admin"].includes(props.variant)
      ? "rgba(28, 86, 145, 0.05)"
      : "none",
}));

const filteredOptions = computed(() =>
  query.value === ''
    ? props.options
    : props.options.filter((item) =>
        item.label
          .toLowerCase()
          .replaceAll(/\s+/g, '')
          .includes(query.value.toLowerCase().replaceAll(/\s+/g, ''))
      )
);

const handleQueryChange = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  query.value = value;
  emit('update:query', value);
};

const handleScroll = (event: Event) => {
  const target = event.target as HTMLElement;
  const scrollTop = target.scrollTop;
  const scrollHeight = target.scrollHeight;
  const clientHeight = target.clientHeight;
  
  // Check if scrolled to bottom (with 10px threshold)
  if (scrollTop + clientHeight >= scrollHeight - 10 && !props.loadingMoreOptions && !props.loadingOptions) {
    emit('load-more-options');
  }
};

watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    const foundOption = props.options.find(opt => opt.value === newValue);
    if (foundOption) {
      selected.value = foundOption;
    }
  } else {
    selected.value = null;
  }
}, { immediate: true });

watch(selected, (newValue) => {
  if (newValue) {
    emit('update:modelValue', newValue.value);
  } else {
    emit('update:modelValue', '');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['search-select w-100', variantClass.value])
  }, [
    _createVNode(_unref(Combobox), {
      modelValue: selected.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selected).value = $event)),
      by: "value"
    }, {
      default: _withCtx(() => [
        (__props.label)
          ? (_openBlock(), _createBlock(_unref(ComboboxLabel), {
              key: 0,
              class: "combobox-label d-flex align-items-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.label) + " ", 1),
                (__props.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
                  : _createCommentVNode("", true),
                (__props.labelIcon)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), {
                      key: 1,
                      class: "ms-1"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "combobox-input-wrapper",
            style: _normalizeStyle(backgroundStyle.value)
          }, [
            _createVNode(_unref(ComboboxInput), _mergeProps({
              class: "combobox-input",
              displayValue: (item) => (item as IOptions)?.label || '',
              onChange: handleQueryChange,
              placeholder: __props.placeholder,
              "data-testid": __props.testId
            }, _ctx.$attrs), null, 16, ["displayValue", "placeholder", "data-testid"]),
            _createVNode(_unref(ComboboxButton), { class: "combobox-button" }, {
              default: _withCtx(() => [
                _createVNode(_unref(CaretDownIcon), {
                  class: "caret-icon",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            })
          ], 4),
          _createVNode(_unref(TransitionRoot), {
            leave: "transition-leave",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            onAfterLeave: _cache[0] || (_cache[0] = () => {
            query.value = ''
            emit('update:query', '')
          })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ComboboxOptions), {
                class: "combobox-options",
                ref_key: "optionsRef",
                ref: optionsRef,
                onScroll: handleScroll
              }, {
                default: _withCtx(() => [
                  (__props.loadingOptions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("div", { class: "spinner" }, null, -1),
                        _createElementVNode("span", { class: "loading-options-text" }, "Loading...", -1)
                      ]))]))
                    : (filteredOptions.value.length === 0 && query.value !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Nothing found. "))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (item) => {
                            return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                              as: "template",
                              key: item.value,
                              value: item
                            }, {
                              default: _withCtx(({ selected, active }) => [
                                _createElementVNode("li", {
                                  class: _normalizeClass(["combobox-option", { active, selected }])
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["option-text", { selected }])
                                  }, _toDisplayString(item.label), 3),
                                  selected
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _createVNode(_unref(CheckmarkIcon), {
                                          class: "checkmark-icon",
                                          "aria-hidden": "true"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128)),
                          (__props.loadingMoreOptions)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("div", { class: "spinner-small" }, null, -1),
                                _createElementVNode("span", { class: "loading-options-text-small" }, "Loading more...", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ], 64))
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})